export const EnhancedError = class EnhancedError extends Error {
    constructor(message, errorObject) {
        super(message);
        this.errorCode = errorObject === null || errorObject === void 0 ? void 0 : errorObject.errorCode;
        this.errorDescription = errorObject === null || errorObject === void 0 ? void 0 : errorObject.errorDescription;
    }
};
export const EnhancedAuthError = class EnhancedAuthError extends EnhancedError {
    constructor(message, errorObject) {
        super(message, errorObject);
    }
};
export const EnhancedAuthNError = class EnhancedAuthNError extends EnhancedAuthError {
    constructor(message, errorObject) {
        super(message, errorObject);
    }
};
export const EnhancedAuthZError = class EnhancedAuthZError extends EnhancedAuthError {
    constructor(message, errorObject) {
        super(message, errorObject);
    }
};
export const badResponse = "Your request could not be processed. Please try again.";
export const badResponseError = new EnhancedError(badResponse);
//# sourceMappingURL=errors.js.map